//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { isMobile as detectMobileDevice } from '@motionelements/core/src/helpers/browser.js';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'video-player-gallery-item',
  mixins: [featureFlagMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    // previews: Object,
    element: Object,
  },
  data() {
    return {
      faPlay,
      player: {},
      nativePreviewPlaying: false,
      nativePreviewVideoEl: null,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.browser.isMobile,
    }),
    isMobileDevice() {
      return this.isMobile ?? detectMobileDevice();
    },
    posterUrl() {
      return _.get(this.element, 'thumbnail.url')
        || _.get(this.element, 'thumbnails.jpg.url')
        || _.get(this.element, 'previews.jpg.url')
        || '';
    },
    playerContainerStyle() {
      if (this.useNativeVideoPreview && this.useNativeControls) {
        return null;
      }
      if (!this.posterUrl) {
        return null;
      }
      return {
        backgroundImage: `url(${this.posterUrl})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    },
    useNativeVideoPreview() {
      return this.isFeatureEnabled('product_preview_native_video');
    },
    useNativeControls() {
      return this.isPopUp && this.useNativeVideoPreview && !this.isMobileDevice;
    },
    shouldPrimeMobilePreview() {
      return this.isPopUp && this.useNativeVideoPreview && this.isMobileDevice;
    },
    showMobileSplash() {
      return this.shouldPrimeMobilePreview && !this.nativePreviewPlaying;
    },
    galleryPlayerClass() {
      return {
        'product-player-video--with-controls': this.useNativeControls,
        'product-player-video--mobile-splash': this.showMobileSplash,
      };
    },
  },
  watch: {
    'element.id'(id, oldId) {
      if (!id || !oldId || id === oldId) {
        return;
      }
      this.nativePreviewPlaying = false;
      this.restartPreviewForElementChange();
    },
  },
  mounted() {
    this.initVideoPlayer();
  },
  beforeDestroy() {
    this.unbindNativePreviewVideoEvents();
    if (this.useNativeVideoPreview) {
      this.$videoPlayer.shutdown();
    } else {
      this.unloadVideoPlayer();
    }
  },
  methods: {
    unloadVideoPlayer() {
      this.$videoPlayer.unload();
    },
    initVideoPlayer() {
      this.$videoPlayer.init(this.$refs.videoPlayer, this.element, {
        controls: this.useNativeControls,
        preferThumbnailSource: false,
      });
      this.$nextTick(() => this.bindNativePreviewVideoEvents());
    },
    bindNativePreviewVideoEvents() {
      this.unbindNativePreviewVideoEvents();
      const video = this.$refs.videoPlayer?.querySelector?.('video');
      if (!video) {
        return;
      }
      this.nativePreviewVideoEl = video;
      video.addEventListener('playing', this.onNativePreviewPlaying);
      video.addEventListener('pause', this.onNativePreviewPause);
    },
    unbindNativePreviewVideoEvents() {
      const video = this.nativePreviewVideoEl;
      if (!video) {
        return;
      }
      video.removeEventListener('playing', this.onNativePreviewPlaying);
      video.removeEventListener('pause', this.onNativePreviewPause);
      this.nativePreviewVideoEl = null;
    },
    onNativePreviewPlaying() {
      this.nativePreviewPlaying = true;
    },
    onNativePreviewPause() {
      const video = this.nativePreviewVideoEl;
      if (video && !video.paused) {
        return;
      }
      this.nativePreviewPlaying = false;
      if (this.shouldPrimeMobilePreview) {
        this.$videoPlayer.unload();
      }
    },
    playMobilePreview() {
      this.$videoPlayer.play();
    },
    restartPreviewForElementChange() {
      if (this.useNativeVideoPreview) {
        this.$videoPlayer.shutdown();
      } else {
        this.unloadVideoPlayer();
      }
      this.initVideoPlayer();
      if (this.useNativeControls) {
        this.$videoPlayer.play();
      }
    },
  },
};
